<template>
  <div class="game-results-container">
    Please click on "Finish Game" to complete the game
  </div>
</template>

<script>
export default {
  name: "GameOverResults",
};
</script>

<style scoped>
.game-results-container {
  font-size: 40px;
  font-weight: bold;
  height: 200px;
  line-height: 200px;
  border-bottom: 1px solid black;
  margin: 30px 50px;
}
</style>